<template>
	<div class="my-order">
		<div ref="orderTabs" class="orderType">
			<div v-for="(item, index) in orderCategory" :key="index" class="type_item"
				:class="{ pitch: status == item.status }" @click="onTabs(item)">
				<span>{{ item.name }}</span>
				<span class="num" v-if="item.showNum">{{ item.showNum }}</span>
			</div>
		</div>
		<el-table ref="orderTable" v-if="!isH5" class="pc-table" :data="tableData"
			style="width: 100%;border-radius: 8px;box-shadow: 0px 3px 16px 0px rgba(0,0,0,0.2);" height="70vh">
			<el-table-column :label="$t('宝贝')" width="380">
				<template slot-scope="scope">
					<div class="commodity pointer" v-for="(item, index) in scope.row.items" @click="gotoDetail(item)">
						<div class="commodity-number">
							{{ item.create_time | onTime(item.create_time) }} | {{ $t('订单号：') }}{{ scope.row.order_sn }}
						</div>
						<div class="commodity-message">
							<img :src="item.product_image" alt="" class="commodity-message-img">
							<div class="commodity-message-box">
								<div class="commodity-message-box-tit line2">{{ item.product_title }}</div>
								<div class="commodity-message-box-txt justify-between align-center">
									<div>
										{{ item.product_sku_text }}
									</div>
									<div v-if="scope.row.product_type != 1">
										<div class="btn-bf" @click.stop="onAfterSale(item)"
											v-if="scope.row.status == 2 && item.refund_status == 0">
											{{ $t('申请售后') }}
										</div>
									</div>
									<div v-else>
										<div class="btn-bf" @click.stop="onAfterSale(item)"
											v-if="scope.row.status > 0 && virtual_goods == 0 && (item.refund_status == 0 || item.refund_status == -1)">
											{{ $t('申请售后') }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('单价')" width="110">
				<template slot-scope="scope">
					<div class="unitPrice" v-for="(item, index) in scope.row.items">
						<div class="unitPrice-b">￥{{ item.product_price }}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('数量')" width="80">
				<template slot-scope="scope">
					<div class="text-14" style="height: 130px;line-height: 130px;"
						v-for="(item, index) in scope.row.items">
						X{{ item.product_num }}
					</div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('实付款')" width="110">
				<template slot-scope="scope">
					<div class="text-14">
						￥{{ scope.row.pay_fee }}
					</div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('交易状态')" width="130">
				<template slot-scope="scope">
					<div class="text-14">
						<div v-if="scope.row.status == 0">{{ $t('等待买家付款') }}</div>
						<div v-if="scope.row.status == 1">{{ $t('等卖家发货') }}</div>
						<div v-if="scope.row.status == 2">{{ $t('待买家收货') }}</div>
						<div v-if="scope.row.status == 3">{{ $t('买家已收货') }}</div>
						<div v-if="scope.row.status == 4">{{ $t('订单已完成') }}</div>
						<div v-if="scope.row.status == -2 || scope.row.status == -1">{{ $t('订单关闭') }}</div>
						<div class="pointer" @click="orderDetali(scope.row)">{{ $t('订单详情') }}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="address" :label="$t('操作')">
				<template slot-scope="scope">
					<div class="btn" v-if="scope.row.product_type != 1">
						<div class="btn-61AC85" @click="onGoPay(scope.row)" v-if="scope.row.status == 0">
							{{ $t('立即付款') }}
						</div>
						<div class="btn-bf" v-if="scope.row.status == 0"
							@click="cancel_show = true, order_id = scope.row.id">
							{{ $t('取消订单') }}
						</div>
						<div class="btn-61AC85" @click="onUrgeDelivery" v-if="scope.row.status == 1">
							{{ $t('催发货') }}
						</div>
						<div class="btn-61AC85" @click="delivery_show = true, order_id = scope.row.id"
							v-if="scope.row.status == 2">
							{{ $t('确认收货') }}
						</div>
						<div class="btn-bf" @click.stop="orderDetali(scope.row)" v-if="scope.row.status == 2">
							{{ $t('查看物流') }}
						</div>
						<div class="btn-61AC85" @click="onEvaluate(scope.row)" v-if="scope.row.status == 3">
							{{ $t('评价') }}
						</div>
						<div class="btn-61AC85" @click="delete_show = true, order_id = scope.row.id"
							v-if="scope.row.status == -2 || scope.row.status == -1 || scope.row.status == 4">
							{{ $t('删除') }}
						</div>
					</div>

					<div class="btn" v-else>
						<div class="btn-61AC85" @click="onGoPay(scope.row)" v-if="scope.row.status == 0">
							{{ $t('立即付款') }}
						</div>
						<div class="btn-bf" v-if="scope.row.status == 0"
							@click="cancel_show = true, order_id = scope.row.id">
							{{ $t('取消订单') }}
						</div>
						<div class="btn-61AC85" @click="onDownload(scope.row)"
							v-else-if="scope.row.status > 0 && canDownloadVirtualGoods(scope.row)">
							{{ $t('下载') }}
						</div>
						<div class="btn-61AC85" @click="onEvaluate(scope.row)" v-if="scope.row.status == 3">
							{{ $t('评价') }}
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<div class="h5-order-list" v-if="isH5">
			<div ref="orderCard" class="h5-order-card" v-for="(row, rIndex) in tableData" :key="rIndex">
				<div class="h5-order-head">
					<span class="h5-order-sn">{{ $t('订单号：') }}{{ row.order_sn }}</span>
					<span class="h5-order-status">{{ orderStatusText(row.status) }}</span>
				</div>
				<div class="commodity pointer" v-for="(item, index) in row.items" :key="index"
					@click="gotoDetail(item)">
					<div class="commodity-message">
						<img :src="item.product_image" alt="" class="commodity-message-img">
						<div class="commodity-message-box">
							<div class="commodity-message-box-tit line2">{{ item.product_title }}</div>
							<div class="commodity-message-box-txt">{{ item.product_sku_text }}</div>
							<div class="h5-order-price">￥{{ item.product_price }} × {{ item.product_num }}</div>
						</div>
					</div>
					<div class="btn-bf" v-if="row.product_type != 1 && row.status == 2 && item.refund_status == 0"
						@click.stop="onAfterSale(item)">{{ $t('申请售后') }}</div>
					<div class="btn-bf"
						v-else-if="row.product_type == 1 && row.status > 0 && virtual_goods == 0 && (item.refund_status == 0 || item.refund_status == -1)"
						@click.stop="onAfterSale(item)">{{ $t('申请售后') }}</div>
				</div>
				<div class="h5-order-foot">
					<div class="h5-order-pay">{{ $t('实付款') }} <span>￥{{ row.pay_fee }}</span></div>
					<div class="h5-order-actions">
						<div class="btn" v-if="row.product_type != 1">
							<div class="btn-61AC85" @click="onGoPay(row)" v-if="row.status == 0">{{ $t('立即付款') }}</div>
							<div class="btn-bf" v-if="row.status == 0" @click="cancel_show = true, order_id = row.id">{{
								$t('取消订单') }}</div>
							<div class="btn-61AC85" @click="onUrgeDelivery" v-if="row.status == 1">{{ $t('催发货') }}</div>
							<div class="btn-61AC85" @click="delivery_show = true, order_id = row.id"
								v-if="row.status == 2">{{ $t('确认收货') }}</div>
							<div class="btn-bf" @click.stop="orderDetali(row)" v-if="row.status == 2">{{ $t('查看物流') }}
							</div>
							<div class="btn-61AC85" @click="onEvaluate(row)" v-if="row.status == 3">{{ $t('评价') }}</div>
							<div class="btn-61AC85" @click="delete_show = true, order_id = row.id"
								v-if="row.status == -2 || row.status == -1 || row.status == 4">{{ $t('删除') }}</div>
							<div class="btn-bf" @click="orderDetali(row)">{{ $t('订单详情') }}</div>
						</div>
						<div class="btn" v-else>
							<div class="btn-61AC85" @click="onGoPay(row)" v-if="row.status == 0">{{ $t('立即付款') }}</div>
							<div class="btn-bf" v-if="row.status == 0" @click="cancel_show = true, order_id = row.id">{{
								$t('取消订单') }}</div>
							<div class="btn-61AC85" @click="onDownload(row)"
								v-else-if="row.status > 0 && canDownloadVirtualGoods(row)">{{ $t('下载') }}</div>
							<div class="btn-61AC85" @click="onEvaluate(row)" v-if="row.status == 3">{{ $t('评价') }}</div>
							<div class="btn-bf" @click="orderDetali(row)">{{ $t('订单详情') }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="h5-empty" v-if="!tableData.length">{{ $t('暂无数据') }}</div>
		</div>

		<div ref="orderPagination" class="order-pagination justify-center">
			<el-pagination layout="prev, pager, next" :page-size="page_size" :total="total" background
				@current-change="onCurrentChange"></el-pagination>
		</div>
		<!-- 订单取消 -->
		<popup :show="cancel_show" :content="$t('确定取消订单吗？')" @close="cancel_show = false" @confirm="onCancelConfirm">
		</popup>
		<!-- 订单删除 -->
		<popup :show="delete_show" :content="$t('确定删除吗？')" @close="delete_show = false" @confirm="onDeleteConfirm">
		</popup>
		<!-- 确认收货 -->
		<popup :show="delivery_show" :content="$t('请收到货后，再确认收货，您确定收货吗？')" @close="delivery_show = false"
			@confirm="onDeliveryConfirm">
		</popup>
	</div>
</template>

<script>
	import UserCenterTemp from '@/components/UserCenterTemp';
	import popup from '../../../components/popup.vue';
	import { orderList, orderCancel, orderDelete, orderCornerMark, notarizeDelivery, downloadLink, getconf } from '@/api/user';

	export default {
		name: 'MyOrder',
		components: {
			'user-center-temp': UserCenterTemp,
			popup,
		},
		data() {
			return {
				activeIndex: 0,
				status: '',//订单类型
				orderCategory: [
					{
						index: 0,
						name: this.$t('所有订单'),
						status: ''
					}, {
						index: 1,
						name: this.$t('待付款'),
						showNum: 0,
						status: 'unpaid'
					}, {
						index: 2,
						name: this.$t('待发货'),
						showNum: 0,
						status: 'nosend'
					}, {
						index: 3,
						name: this.$t('待收货'),
						showNum: 0,
						status: 'noget'
					}, {
						index: 4,
						name: this.$t('待评价'),
						showNum: 0,
						status: 'nocomment'
					}, {
						index: 5,
						name: this.$t('已完成'),
						showNum: 0,
						status: 'completed'
					}
				],
				tableData: [],//订单列表
				page_size: 0,//单页数量
				total: 0,//订单总数
				page: 1,//页数
				cancel_show: false,//取消弹窗
				order_id: '',//订单id
				delete_show: false,//删除弹窗
				delivery_show: false,//收货弹窗
				isH5: typeof window !== 'undefined' && window.innerWidth < 768,

				virtual_goods: '',//是否允许虚拟产品退款
				// 订单页面入场动画实例，用于组件销毁时释放动画资源
				orderEntranceAnimation: null,
			}
		},
		filters: {
			onTime(value) {
				// 将时间戳转换为日期对象
				let date = new Date(value);
				// 获取年月日
				let year = date.getFullYear();
				let month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，+1后补零
				let day = String(date.getDate()).padStart(2, '0'); // 日期补零

				let YYYYMMDD = `${year}-${month}-${day}`
				return YYYYMMDD
			}
		},
		mounted() {
			this.updateIsH5();
			window.addEventListener('resize', this.updateIsH5);
			this.onOrderList()
			this.onOrderCornerMark();
			this.onGetconf()
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateIsH5);
			if (this.orderEntranceAnimation) {
				this.orderEntranceAnimation.kill()
			}
		},
		methods: {
			/** 播放订单列表的入场动效 */
			playOrderEntranceAnimation() {
				if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					return
				}
				if (this.orderEntranceAnimation) {
					this.orderEntranceAnimation.kill()
				}
				const orderContent = this.isH5
					? (this.$refs.orderCard || [])
					: [this.$refs.orderTable && this.$refs.orderTable.$el]
				const targets = [this.$refs.orderTabs]
					.concat(orderContent)
					.concat([this.$refs.orderPagination])
					.filter(Boolean)
				this.orderEntranceAnimation = this.$gsap.from(targets, {
					y: 16,
					opacity: 0,
					duration: 0.45,
					stagger: 0.08,
					ease: 'power2.out',
				})
			},
			updateIsH5() {
				this.isH5 = window.innerWidth < 768;
			},
			onCurrentChange(e) {
				this.page = e;
				this.onOrderList()
			},
			/**获取配置 */
			onGetconf() {
				getconf({ module: 'system' }).then(res => {
					this.virtual_goods = res.data.virtual_goods
				})
			},
			/**下载 */
			onDownload(e) {
				if (!this.canDownloadVirtualGoods(e)) {
					return
				}
				let data = {
					order_sn: e.order_sn,
					product_sku_id: e.items[0].product_sku_price_id
				}
				downloadLink(data).then(res => {
					if (res.code == 1) {
						window.open(res.data.url);
						this.$message.success(this.$t('下载成功'));
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			/**是否允许下载虚拟商品：所有商品未申请售后或售后被拒绝，且未超过下载期限时才允许下载 */
			canDownloadVirtualGoods(order) {
				return Array.isArray(order.items) && order.items.length > 0
					&& order.items.every(item => (item.refund_status == 0 || item.refund_status == -1)
						&& !this.isVirtualGoodsDownloadExpired(order.pay_time, item.time_day))
			},
			/**
			 * 判断虚拟商品下载期限是否已过：time_day 为空时不限制下载。
			 * @param {number|string} payTime 支付时间戳（兼容秒级、毫秒级时间戳）
			 * @param {number|string} timeDay 商品可下载天数
			 * @returns {boolean} 是否已超过下载期限
			 */
			isVirtualGoodsDownloadExpired(payTime, timeDay) {
				if (timeDay === '' || timeDay === null || timeDay === undefined) {
					return false
				}
				const downloadDays = Number(timeDay)
				const paymentTimestamp = Number(payTime)
				if (!Number.isFinite(downloadDays) || !Number.isFinite(paymentTimestamp)) {
					return false
				}
				const paymentTimeMs = paymentTimestamp < 100000000000 ? paymentTimestamp * 1000 : paymentTimestamp
				const paidDays = Math.floor((Date.now() - paymentTimeMs) / (24 * 60 * 60 * 1000))
				return paidDays > downloadDays
			},
			/**确认收货 */
			onDeliveryConfirm() {
				notarizeDelivery({ id: this.order_id }).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
					this.onOrderList()
					this.onOrderCornerMark();
					this.delivery_show = false
				})
			},
			/**催发货 */
			onUrgeDelivery() {
				this.$message.success(this.$t('催发货成功，商家已收到提示'));
			},
			/**订单角标 */
			onOrderCornerMark() {
				orderCornerMark().then(res => {
					let data = res.data
					console.log(data);
					this.orderCategory[0].showNum = data.total_num
					this.orderCategory[1].showNum = data.unpaid
					this.orderCategory[2].showNum = data.nosend
					this.orderCategory[3].showNum = data.noget
					this.orderCategory[4].showNum = data.nocomment
					// this.orderCategory[5].showNum = data.unpaid
				})
			},
			/**确认删除 */
			onDeleteConfirm() {
				orderDelete({ id: this.order_id }).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
					this.onOrderList()
					this.onOrderCornerMark();
					this.delete_show = false
				})
			},
			/**确认取消 */
			onCancelConfirm() {
				orderCancel({ id: this.order_id }).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
					this.onOrderList()
					this.onOrderCornerMark();
					this.cancel_show = false
				})
			},
			/**评价 */
			onEvaluate(e) {
				this.$router.push({ name: 'Evaluate', params: { id: e.id } });
			},
			/**去支付 */
			onGoPay(e) {
				this.$router.push({ name: "placeOrder", params: { order: encodeURIComponent(JSON.stringify(e)) } });
			},
			orderStatusText(status) {
				const map = {
					'0': this.$t('等待买家付款'),
					'1': this.$t('等卖家发货'),
					'2': this.$t('待买家收货'),
					'3': this.$t('买家已收货'),
					'4': this.$t('订单已完成'),
					'-1': this.$t('订单关闭'),
					'-2': this.$t('订单关闭'),
				};
				return map[String(status)] || '';
			},
			/**商品详情 */
			gotoDetail(e) {
				this.$router.push({ name: 'ProductDetails', params: { id: e.product_id } })
			},
			/**订单列表 */
			onOrderList() {
				let data = {
					type: 'goods',
					status: this.status,
					page: this.page
				}
				orderList(data).then(res => {
					// console.log(res.data.data);
					this.page_size = res.data.per_page
					this.total = res.data.total
					let data = res.data.data
					this.tableData = data
					this.$nextTick(() => {
						this.playOrderEntranceAnimation()
					})
				})
			},
			/**去申请售后 */
			onAfterSale(e) {
				this.$router.push({ name: 'RefundOption', params: { order: encodeURIComponent(JSON.stringify(e)) } });
			},
			/**标签点击 */
			onTabs(e) {
				this.status = e.status
				this.onOrderList()
				this.onOrderCornerMark();
			},
			// 订单详情
			orderDetali(e) {
				this.$router.push({ name: 'OrderDetail', params: { id: e.id } });
			}
		}
	};
</script>

<style scoped lang="scss">
	.my-order {
		width: 1040px;
		background: #fff;
		overflow: hidden;
		box-sizing: border-box;
		padding: 0 10px;
	}

	.orderType {
		padding: 24px;
		display: flex;

		.type_item {
			color: #333;
			font-size: 16px;
			margin-right: 48px;
			cursor: pointer;
		}

		.pitch {
			/* // color: #FD3B00; */
			font-weight: bold;
			padding-bottom: 8px;
			border-bottom: 3px solid #000000;
		}

		.num {
			/* // color: #FD3B00; */
		}
	}

	/*商品*/
	.commodity {
		.commodity-number {
			font-size: 14px;
			color: #333333;
			margin-bottom: 8px;
		}

		.commodity-message {
			display: flex;
			align-items: center;

			.commodity-message-img {
				width: 100px;
				height: 100px;
				border-radius: 8px;
				object-fit: cover;
				object-position: center;
				display: block;
			}

			.commodity-message-box {
				margin-left: 16px;
				width: calc(100% - 116px);
				height: 100px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.commodity-message-box-tit {
					font-size: 14px;
					color: #333333;
					/* // margin-bottom: 18px; */
				}

				.commodity-message-box-txt {
					font-size: 14px;
					color: #999999;
				}
			}
		}
	}

	/*单价 */
	.unitPrice {
		font-size: 14px;
		height: 130px;
		display: flex;
		flex-direction: column;
		justify-content: center;

		.unitPrice-t {
			color: #999999;
			text-decoration-line: line-through;
		}

		.unitPrice-b {
			color: #333333;
		}
	}

	/*按钮 */
	.btn {
		div {
			width: 96px;
			height: 32px;
			border-radius: 6px;
			font-size: 14px;
			text-align: center;
			line-height: 32px;
			margin-bottom: 6px;
			cursor: pointer;
		}

		.btn-61AC85 {
			background: #000000;
			color: #FFFFFF;
		}

		.btn-bf {
			background: #cecece;
			color: #333;
		}
	}

	.btn-bf {
		width: 96px;
		height: 32px;
		border-radius: 6px;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		cursor: pointer;
		background: #cecece;
		color: #333;
	}

	.order-pagination {
		padding-top: 32px;
	}

	.h5-order-list {
		display: none;
	}

	@media (max-width: 767px) {
		.my-order {
			width: 100%;
			max-width: 100%;
			padding: 0;
			overflow: visible;
			background: transparent;
			box-sizing: border-box;
		}

		.orderType {
			padding: 4px 0 12px;
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}

			.type_item {
				flex-shrink: 0;
				margin-right: 16px;
				font-size: 14px;
				white-space: nowrap;
			}
		}

		.h5-order-list {
			display: block;
		}

		.h5-order-card {
			background: #fff;
			border-radius: 8px;
			padding: 12px;
			margin-bottom: 12px;
			box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
			box-sizing: border-box;
		}

		.h5-order-head {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 8px;
			padding-bottom: 10px;
			margin-bottom: 10px;
			border-bottom: 1px solid #eee;
			font-size: 12px;
			color: #999;
		}

		.h5-order-sn {
			flex: 1;
			min-width: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.h5-order-status {
			flex-shrink: 0;
			color: #000;
		}

		.h5-order-card .commodity {
			margin-bottom: 10px;
		}

		.h5-order-card .commodity-message {
			align-items: flex-start;
		}

		.h5-order-card .commodity-message-img {
			width: 72px;
			height: 72px;
			flex-shrink: 0;
		}

		.h5-order-card .commodity-message-box {
			height: auto;
			min-width: 0;
			width: calc(100% - 88px);
		}

		.h5-order-price {
			margin-top: 6px;
			color: #333;
			font-size: 14px;
		}

		.h5-order-card .commodity>.btn-bf {
			margin-top: 12px;
			margin-left: auto;
		}

		.h5-order-foot {
			padding-top: 10px;
			border-top: 1px solid #eee;
		}

		.h5-order-pay {
			text-align: right;
			font-size: 14px;
			margin-bottom: 10px;

			span {
				font-size: 16px;
				font-weight: bold;
			}
		}

		.h5-order-actions .btn {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-end;
			gap: 8px;

			div {
				margin-bottom: 0;
			}
		}

		.h5-empty {
			padding: 48px 0;
			text-align: center;
			color: #999;
			font-size: 14px;
		}

		.order-pagination {
			padding-top: 8px;
			overflow-x: auto;
			display: flex;
			justify-content: center;
			width: 100%;

			/deep/ .el-pagination {
				margin: 0 auto;
				justify-content: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/my/components/MyOrder2.vue